import _asyncToGenerator from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/experian-public-site-tng/experian-public-site-tng/node_modules/@babel/runtime/regenerator/index.js";
import { concatBuffers } from './utils/byteUtils';
import { noop } from './utils/functionUtils';
/**
 * Read bytes from a ReadableStream until the end of the stream.
 * Returns the bytes if collectStreamBody is true, otherwise returns undefined.
 */
export function readBytesFromStream(_x, _x2) {
  return _readBytesFromStream.apply(this, arguments);
}
function _readBytesFromStream() {
  _readBytesFromStream = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream, options) {
    var reader, chunks, result;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          reader = stream.getReader();
          chunks = [];
        case 1:
          if (!true) {
            _context.next = 4;
            break;
          }
          _context.next = 2;
          return reader.read();
        case 2:
          result = _context.sent;
          if (!result.done) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("continue", 4);
        case 3:
          if (options.collectStreamBody) {
            chunks.push(result.value);
          }
          _context.next = 1;
          break;
        case 4:
          reader.cancel()["catch"](
          // we don't care if cancel fails, but we still need to catch the error to avoid reporting it
          // as an unhandled rejection
          noop);
          return _context.abrupt("return", options.collectStreamBody ? concatBuffers(chunks) : undefined);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _readBytesFromStream.apply(this, arguments);
}